import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { LocationAutocompleteComponent } from '../code-dropdown/components/location-autocomplete/location-autocomplete.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TaskAssignmentService } from '@services/task-assignment.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { SaveBtn } from '@shared/components/save-btn/save-btn.component';
import { TranslateModule } from '@ngx-translate/core';
import { CancelBtn } from '@shared/components/cancel-btn/cancel-btn.component';
import { PatientService } from '@services/patient.service';
import { LocatingSpace } from '@interfaces/location/locating-space';
import { RoomLocation } from '@interfaces/location/room-location';

@Component({
  selector: 'app-dialog',
  templateUrl: './create-task-modal.component.html',
  styleUrls: ['./create-task-modal.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogClose,
    MatDialogTitle,
    MatInputModule,
    LocationAutocompleteComponent,
    ReactiveFormsModule,
    SaveBtn,
    TranslateModule,
    CancelBtn,
  ],
})
export class CreateTaskModal {
  form: FormGroup = new FormGroup({
    location: new FormControl(),
    description: new FormControl(),
  });
  private taskAssignmentService = inject(TaskAssignmentService);
  private patientService = inject(PatientService);

  save() {
    this.taskAssignmentService.sendNewTask(this.form.value);
  }

  locationValue = toSignal(this.form.get('location')!.valueChanges, {
    initialValue: '',
  });

  filteredPatient = computed(() => {
    const location = this.locationValue() as RoomLocation | LocatingSpace | string;
    const patients = this.patientService.patients();
    const roomName =
      typeof location === 'string'
        ? location
        : location && 'room' in location
          ? location.room
          : '';
    const finderPatient =
      roomName.length > 2 && patients
        ? patients.find((p) =>
            p.room.toLowerCase().includes(roomName.toLowerCase()),
          )
        : undefined;

    return finderPatient?.name;
  });
}
